import { type ReactNode } from 'react';
import { useSlots } from '@gonfalon/react/useSlots';
import { ButtonGroup, Heading, Text } from '@launchpad-ui/components';

import { EmptyStateAside } from '../EmptyStateAside';

import styles from './BaseEmptyState.module.css';

export function BaseEmptyState({ children }: { children: ReactNode }) {
  const [{ heading, mainText, ctas, aside }] = useSlots(children, {
    heading: Heading,
    mainText: Text,
    ctas: ButtonGroup,
    aside: EmptyStateAside,
  });

  return (
    <div className={styles.root}>
      <div className={styles.main}>
        <section>
          {heading}
          {mainText}
        </section>
        <section>{ctas}</section>
      </div>
      <aside>{aside}</aside>
    </div>
  );
}
